import { Info, Mail, Wrench } from "lucide-react";

export const CONTACT_GENERAL = "dosa.office@thapar.edu";
export const CONTACT_TECHNICAL = "itmh@thapar.edu";

export function LegalCallout({ title, children }) {
  return (
    <div className="lc-callout" role="note">
      <Info size={18} aria-hidden="true" />
      <p>{title && <strong>{title}</strong>}{children}</p>
    </div>
  );
}

export function LegalContact() {
  return (
    <div className="lc-contact">
      <div className="lc-contact-card">
        <span className="lc-icon"><Mail size={18} aria-hidden="true" /></span>
        <div>
          <small>General / administrative</small>
          <a href={`mailto:${CONTACT_GENERAL}`}>{CONTACT_GENERAL}</a>
        </div>
      </div>
      <div className="lc-contact-card">
        <span className="lc-icon"><Wrench size={18} aria-hidden="true" /></span>
        <div>
          <small>Technical</small>
          <a href={`mailto:${CONTACT_TECHNICAL}`}>{CONTACT_TECHNICAL}</a>
        </div>
      </div>
    </div>
  );
}

/* Descriptive overview of the platform's service categories (not a workflow guide). */
export function PlatformScope({ groups }) {
  return (
    <div className="lc-scope">
      {groups.map(({ title, icon: Icon, items }) => (
        <div className="lc-scope-tile" key={title}>
          <div className="lc-scope-head">
            <span className="lc-icon"><Icon size={18} aria-hidden="true" /></span>
            <h3>{title}</h3>
          </div>
          <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul>
        </div>
      ))}
    </div>
  );
}
